import React from 'react';
import dayjs from "dayjs";

import {CircularProgress} from "@mui/joy";
import Box from '@mui/joy/Box';

// components
import BaseApi from "../../utils/BaseApi";
import withRouter from "../../utils/withRouter";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import {customRange, deleteArrayItemByKeyValue, downloadBlob} from "../../utils/misc";
import retrievePermission from "../../utils/retrievePermission";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import CommonCallBackButton from "../Common/CommonCallBackButton";

// icons
import DeleteIcon from "@mui/icons-material/Delete";
import BankTransactionUploadModal from "./BankTransactionUploadModal";
import {flushSync} from "react-dom";


class BankTransactionList extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            updatePermission: 0,
            uploadPermission: 0,
            deletePermission: 0,
            bankTransactions: null,
            filters: {
                year: new Date().getFullYear()
            },
            pages: null,
        };
    }

    async componentDidMount() {
        await this.retrieveBankTransactions();
        await this.retrieveFilterFields();
        await this.retrievePermission();
    }

    async retrievePermission() {
        let updatePermission = await retrievePermission(
            'BankTransactionViewSet',
            'partial_update',
            this.context.subscriberObject
        );
        let uploadPermission = await retrievePermission(
            'BankTransactionViewSet',
            'upload',
            this.context.subscriberObject
        );
        let deletePermission = await retrievePermission(
            'BankTransactionViewSet',
            'destroy',
            this.context.subscriberObject
        );
        await this.setState(
            {
                updatePermission: updatePermission,
                uploadPermission: uploadPermission,
                deletePermission: deletePermission,
            }
        );
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveBankTransactions();
        }
    }

    async filterCallBack(filters){
        filters['category__isnull'] = filters['category__isnull'] !== 'false'
        await this.setState({
            filters: filters
        });
        flushSync(() => {})
        await this.retrieveBankTransactions();
    }

    async retrieveFilterFields(){
        const url = 'bank_transaction/update_form/';
        const api = new BaseApi();
        let params = {
            fields: JSON.stringify(
                [
                    'direction',
                    'category',
                ]
            )
        }
        let response = await api.get(url, params);
        let fields = response.data
        fields = deleteArrayItemByKeyValue(
            fields,
            'name',
            'submitButton'
        );
        await this.setState({
            filterFields: [
                ...fields,
                {
                    name: 'year',
                    label: 'Год',
                    xs: 12,
                    sm: null,
                    md: null,
                    lg: null,
                    xl: null,
                    required: false,
                    default: null,
                    type: 'select',
                    empty: true,
                    options: customRange(2024, new Date().getFullYear() + 1).map(value => (
                        {value: value, label: value}
                    ))
                },
                {
                    name: 'category__isnull',
                    label: 'Категория не указана',
                    xs: 12,
                    sm: null,
                    md: null,
                    lg: null,
                    xl: null,
                    required: false,
                    default: null,
                    type: 'checkbox',
                    empty: true,
                },
                {
                    name: 'search',
                    label: 'Поисковая строка',
                    xs: 12,
                    sm: null,
                    md: null,
                    lg: null,
                    xl: null,
                    required: false,
                    type: 'input',
                },
            ]
        });
    }

    async retrieveBankTransactions() {
        const url = 'bank_transaction/';
        const api = new BaseApi();
        let params = {
            ordering: 'date'
        };
        params = {...params, ...this.state.filters};
        if (params.year === 'NaN'){
            delete params.year
        }
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        let response = await api.get(url, params);
        if (response.status === 404){
            params['page'] = 1;
        }
        response = await api.get(url, params);
        this.setState(
            {
                bankTransactions: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }

    async downloadCallBack() {
        const api = new BaseApi();
        const url = 'bank_transaction/list_download/';
        let params = {
            ordering: 'date'
        };
        params = {...params, ...this.state.filters};
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        let response = await api.get(url, params);
        if (response.status === 404){
            params['page'] = 1;
        }
        response = await api.get(url, params);
        downloadBlob(
            [response.data, ],
            'bank_transactions.csv'
        )
    }

    async delete(id) {
        const url = `bank_transaction/${id}/`;
        const api = new BaseApi();
        await api.delete(url);
        await this.retrieveBankTransactions()
    }

    render() {
        if (!this.state.bankTransactions) {
            return (<CircularProgress/>)
        }
        if (!this.state.pages) {
            return (<CircularProgress/>)
        }
        if (!this.state.filterFields) {
            return (<CircularProgress/>)
        }
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    my: 1,
                    gap: 1,
                    flexWrap: 'wrap',
                    '& > *': {
                        minWidth: 'clamp(0px, (500px - 100%) * 999, 100%)',
                        flexGrow: 1,
                    },
                }}
            >
                <CommonPaginatedTable
                    key={crypto.randomUUID()}
                    title={'Банковские транзакции'}
                    url={'financial/bank_transaction'}
                    extraComponents={[
                        ...this.state.uploadPermission?[
                        {
                            component: BankTransactionUploadModal,
                            componentProps: {
                            },
                            callBack: this.retrieveBankTransactions.bind(this),
                        }
                        ]:[],
                    ]}
                    data={this.state.bankTransactions}
                    pages={this.state.pages}
                    pageNumber={this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1}
                    filterFields={this.state.filterFields}
                    filterCallBack={this.filterCallBack.bind(this)}
                    filterValue={this.state.filters}
                    download={{
                        callBack: this.downloadCallBack.bind(this),
                    }}
                    fields={[
                        {
                            title: '',
                            name: 'direction_human',
                            visible: true,
                            chip: true,
                            color_rule: (value, comparison) => (value==='INCOMING'?'warning':'primary'),
                            color_value: 'direction',
                            width: '110px',
                        },
                        {
                            title: 'Номер',
                            name: 'number',
                            visible: true,
                            width: '60px',
                        },
                        {
                            title: 'Назначение платежа',
                            name: 'title',
                            visible: true,
                            width: '30%'
                        },
                        {
                            title: 'Контрагент',
                            name: 'contractor',
                            visible: true,
                        },
                        {
                            title: 'Счет',
                            name: 'contractor_account',
                            visible: true,
                        },
                        {
                            title: 'Категория',
                            name: 'category.title',
                            visible: true,
                            edit: {
                                permission: this.state.updatePermission,
                                fields: ['category', ],
                                obj: {
                                    id: 'id',
                                    category: 'category.id',
                                },
                                baseUrl: 'bank_transaction',
                                callBack: this.retrieveBankTransactions.bind(this),
                            },
                        },
                        {
                            title: 'Сумма',
                            name: 'cost',
                            visible: true,
                        },
                        {
                            title: 'Дата',
                            name: 'date',
                            visible: true,
                            preProcess: (value) => (value?dayjs(value).format('DD.MM.YYYY'):value),
                            width: '100px',
                        },
                        {
                            title: '',
                            visible: this.state.deletePermission,
                            component: CommonCallBackButton,
                            componentProps: {
                                propsObject: 'componentObj',
                                propsObjectKey: 'id',
                                icon: DeleteIcon,
                                color: 'danger',
                            },
                            callBack: this.delete.bind(this),
                        },
                    ]
                    }
                />
            </Box>
        )
    }
}

export default withRouter(BankTransactionList)
